"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _followBook = require("../../api/followBook");

var _oss = require("../../utils/oss");

var _qrcode = require("../../utils/qrcode");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var stateMap = {
  1: '草稿箱',
  2: '审核中',
  3: '已发布',
  4: '未通过',
  5: '回收站'
};
var _default = {
  name: 'Book',
  filters: {
    showStatus: function showStatus(state) {
      return stateMap[state];
    }
  },
  data: function data() {
    return {
      sectionCode: '',
      SyncSectionData: [],
      allSyncGrade: [],
      gradeCode: '',
      volumeCodetion: [],
      volumeCode: '',
      periodCodetion: [],
      periodCode: '',
      categoryTion: [],
      category: '',
      syncEditiontion: [],
      editionCode: '',
      data: undefined,
      totalElements: 1,
      currentPage: 1,
      pageSize: 10,
      ossUrl: _oss.ossUrl,
      deleteLoading: false,
      loading: {
        list: false,
        status: {},
        delete: {}
      },
      tableHeight: 759,
      bookData: [{
        id: 0,
        title: '资源总码',
        name: undefined
      }, {
        id: 0,
        scene: 1,
        title: '单词总码',
        name: undefined
      }, {
        id: 0,
        scene: 2,
        title: '会话总码',
        name: undefined
      }],
      alertId: 0,
      dialogVisible: false
    };
  },
  computed: {
    bookListStyle: function bookListStyle() {
      return {
        height: "".concat(this.$store.state.app.availableHeight, "px")
      };
    } // 控制页面高度

  },
  watch: {
    currentPage: function currentPage() {
      this.updateList();
    },
    pageSize: function pageSize() {
      this.updateList();
    },
    '$store.state.app.availableHeight': function $storeStateAppAvailableHeight() {
      this.updateTableHeight();
    } // 当页面变化时候，更新 table 的高度

  },
  mounted: function mounted() {
    this.updateTableHeight(); // 更新 table 的可显示高度

    this.updateList();
    this.getAllSyncSectionApi();
    /* 学段接口 */

    this.getAllSyncGradeApi();
    /* 年级 */

    this.getAllVolumeCodeApi();
    /* 上下册 */

    this.getAllperiodCodeApi();
    /* 版本 */
    // this.getAllCategoryCodeApi();/* 分类 */

    this.getAllSyncEditionApi();
    /* banben */
  },
  methods: {
    /* 学段id 发生改变 */
    handleSectionCode: function () {
      var _handleSectionCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.sectionCode = val;
                _context.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSectionCode(_x) {
        return _handleSectionCode.apply(this, arguments);
      }

      return handleSectionCode;
    }(),

    /* 年级 */
    handleGradeCode: function () {
      var _handleGradeCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.gradeCode = val;
                _context2.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleGradeCode(_x2) {
        return _handleGradeCode.apply(this, arguments);
      }

      return handleGradeCode;
    }(),

    /* 上下册 */
    handleVolumeCode: function () {
      var _handleVolumeCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.volumeCode = val;
                _context3.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleVolumeCode(_x3) {
        return _handleVolumeCode.apply(this, arguments);
      }

      return handleVolumeCode;
    }(),

    /* 版ci */
    handlePeriod: function () {
      var _handlePeriod = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(val) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.periodCode = val;
                _context4.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handlePeriod(_x4) {
        return _handlePeriod.apply(this, arguments);
      }

      return handlePeriod;
    }(),

    /* 版本 */
    handleEditionCode: function () {
      var _handleEditionCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(val) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.editionCode = val;
                _context5.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleEditionCode(_x5) {
        return _handleEditionCode.apply(this, arguments);
      }

      return handleEditionCode;
    }(),
    //* 分类*/
    handleCategory: function () {
      var _handleCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(val) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.category = val;
                _context6.next = 3;
                return this.updateList();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function handleCategory(_x6) {
        return _handleCategory.apply(this, arguments);
      }

      return handleCategory;
    }(),

    /* 学段接口 */
    getAllSyncSectionApi: function () {
      var _getAllSyncSectionApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return (0, _followBook.getAllSyncSection)();

              case 3:
                res = _context7.sent;
                this.SyncSectionData = res.data;
                this.SyncSectionData.unshift({
                  name: '全部',
                  adcode: ''
                });
                console.log('阶段数据', res.data);
                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                this.$notify({
                  title: '查询失败',
                  message: _context7.t0.message,
                  type: 'error'
                });

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));

      function getAllSyncSectionApi() {
        return _getAllSyncSectionApi.apply(this, arguments);
      }

      return getAllSyncSectionApi;
    }(),

    /* 年级接口 */
    getAllSyncGradeApi: function () {
      var _getAllSyncGradeApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return (0, _followBook.getAllSyncGrade)();

              case 3:
                res = _context8.sent;
                this.allSyncGrade = res.data;
                this.allSyncGrade.unshift({
                  name: '全部',
                  adcode: ''
                });
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);
                this.$notify({
                  title: '查询年级失败',
                  message: _context8.t0.message,
                  type: 'error'
                });

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 8]]);
      }));

      function getAllSyncGradeApi() {
        return _getAllSyncGradeApi.apply(this, arguments);
      }

      return getAllSyncGradeApi;
    }(),

    /* 上下册接口 */
    getAllVolumeCodeApi: function () {
      var _getAllVolumeCodeApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return (0, _followBook.getAllSyncVolume)();

              case 3:
                res = _context9.sent;
                this.volumeCodetion = res.data;
                this.volumeCodetion.unshift({
                  name: '全部',
                  adcode: ''
                });
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](0);
                this.$notify({
                  title: '查询上下册失败',
                  message: _context9.t0.message,
                  type: 'error'
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 8]]);
      }));

      function getAllVolumeCodeApi() {
        return _getAllVolumeCodeApi.apply(this, arguments);
      }

      return getAllVolumeCodeApi;
    }(),

    /* 版ci */
    getAllperiodCodeApi: function () {
      var _getAllperiodCodeApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return (0, _followBook.getAllperiodCode)();

              case 3:
                res = _context10.sent;
                this.periodCodetion = res.data;
                this.periodCodetion.unshift({
                  name: '全部',
                  adcode: ''
                });
                _context10.next = 11;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);
                this.$notify({
                  title: '查询上下册失败',
                  message: _context10.t0.message,
                  type: 'error'
                });

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function getAllperiodCodeApi() {
        return _getAllperiodCodeApi.apply(this, arguments);
      }

      return getAllperiodCodeApi;
    }(),

    /* 版本 */
    getAllSyncEditionApi: function () {
      var _getAllSyncEditionApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return (0, _followBook.getAllSyncEdition)();

              case 3:
                res = _context11.sent;
                this.syncEditiontion = res.data;
                this.syncEditiontion.unshift({
                  name: '全部',
                  adcode: ''
                });
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);
                this.$notify({
                  title: '查询版本失败',
                  message: _context11.t0.message,
                  type: 'error'
                });

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function getAllSyncEditionApi() {
        return _getAllSyncEditionApi.apply(this, arguments);
      }

      return getAllSyncEditionApi;
    }(),
    // /* fenlei */
    // async getAllCategoryCodeApi() {
    //   try {
    //     const res = await getCategoryView();
    //     this.categoryTion = res.data;
    //     console.log(res.data);
    //   } catch (e) {
    //     this.$notify({
    //       title: '查询分类失败',
    //       message: e.message,
    //       type: 'error',
    //     });
    //   }
    // },
    updateList: function () {
      var _updateList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var message;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.loading.list = true;
                _context12.prev = 1;
                _context12.next = 4;
                return this.getList();

              case 4:
                _context12.next = 10;
                break;

              case 6:
                _context12.prev = 6;
                _context12.t0 = _context12["catch"](1);
                message = _context12.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 10:
                _context12.prev = 10;
                this.loading.list = false;
                return _context12.finish(10);

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[1, 6, 10, 13]]);
      }));

      function updateList() {
        return _updateList.apply(this, arguments);
      }

      return updateList;
    }(),
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var _yield$readBookList, message;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return (0, _followBook.readBookList)(this.currentPage, this.pageSize, this.sectionCode, this.gradeCode, this.volumeCode, this.periodCode, this.category, this.editionCode);

              case 3:
                _yield$readBookList = _context13.sent;
                this.data = _yield$readBookList.data;
                this.totalElements = _yield$readBookList.totalElements;
                _context13.next = 12;
                break;

              case 8:
                _context13.prev = 8;
                _context13.t0 = _context13["catch"](0);
                message = _context13.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 8]]);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    handleModifyStatus: function () {
      var _handleModifyStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref3, state) {
        var resourceOpenId, message;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                resourceOpenId = _ref3.resourceOpenId;
                this.$set(this.loading.status, resourceOpenId, true);
                _context14.prev = 2;
                _context14.next = 5;
                return (0, _followBook.updateBook)(resourceOpenId, {
                  state: state
                });

              case 5:
                _context14.next = 7;
                return this.getList();

              case 7:
                _context14.next = 13;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](2);
                message = _context14.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 13:
                _context14.prev = 13;
                this.$set(this.loading.status, resourceOpenId, false);
                return _context14.finish(13);

              case 16:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 9, 13, 16]]);
      }));

      function handleModifyStatus(_x7, _x8) {
        return _handleModifyStatus.apply(this, arguments);
      }

      return handleModifyStatus;
    }(),
    // 打开弹窗
    alertQRCode: function alertQRCode(data) {
      this.dialogVisible = true;
      this.alertId = data.id;
      console.log(data); // eslint-disable-next-line no-plusplus

      for (var i = 0; i < this.bookData.length; i++) {
        var dataId = data.id;

        if (i === 1) {
          dataId = "sceneA".concat(dataId);
          this.bookData[i].scence = 0;
        } else if (i === 2) {
          dataId = "sceneB".concat(dataId);
          this.bookData[i].scence = 1;
        }

        this.bookData[i].name = data.title;
        this.bookData[i].id = dataId;
      }

      console.log(this.bookData);
    },
    // 二维码处理
    openDialog: function openDialog() {
      (0, _qrcode.makeQRCode)(this.bookData);
    },
    // 下载二维码
    downLoadPNGClick: function downLoadPNGClick(item) {
      (0, _qrcode.downLoadPNG)(item, 0);
    },
    handleCreate: function handleCreate() {
      this.$router.push({
        name: 'BookCreate'
      });
    },
    handleUpdate: function handleUpdate(_ref5) {
      var openId = _ref5.resourceOpenId;
      this.$router.push({
        name: 'BookUpdate',
        params: {
          openId: openId
        }
      });
    },
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref6) {
        var resourceOpenId, message;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                resourceOpenId = _ref6.resourceOpenId;
                this.$set(this.loading.delete, resourceOpenId, true);
                _context15.prev = 2;
                _context15.next = 5;
                return (0, _followBook.deleteBook)(resourceOpenId);

              case 5:
                _context15.next = 7;
                return this.getList();

              case 7:
                _context15.next = 13;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](2);
                message = _context15.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 13:
                _context15.prev = 13;
                this.$set(this.loading.delete, resourceOpenId, false);
                return _context15.finish(13);

              case 16:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[2, 9, 13, 16]]);
      }));

      function handleDelete(_x9) {
        return _handleDelete.apply(this, arguments);
      }

      return handleDelete;
    }(),
    handleRead: function handleRead(_ref8) {
      var openId = _ref8.resourceOpenId,
          id = _ref8.id;
      this.$router.push({
        name: 'BookContent',
        query: {
          openId: openId,
          id: id
        }
      });
    },
    updateTableHeight: function updateTableHeight() {
      var _this = this;

      // 更新 table 的可显示高度
      try {
        this.$nextTick(function () {
          try {
            _this.tableHeight = _this.$refs.tableContainer.offsetHeight - 1;
          } catch (e) {
            console.error(e);
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
  }
};
exports.default = _default;